/** @format */
import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { TimelineNoteValues } from './timelineAddNoteModal-ng.component';

/**
 * @deprecated
 */
@Directive({
    // eslint-disable-next-line @angular-eslint/directive-selector
    selector: 'timeline-note-modal',
    standalone: false,
})
export class TimelineNoteModalDirective extends UpgradeComponent {
    @Output() close: EventEmitter<any>;
    @Output() dismiss: EventEmitter<void>;
    @Input() resolve: TimelineNoteValues;

    constructor(elementRef: ElementRef<any>, injector: Injector) {
        super('timelineNoteModal', elementRef, injector);
    }
}
